import React from 'react'
import './Footer.css'

function Footer() {
    return (
        <div className='footer'>
            <p>© 2021 Ahavá. Todos los derechos reservados. 2021</p>
            <p>Desarrollado y diseñado por © 2021 DonTrino</p>
        </div>
    )
}

export default Footer